import React from "react";
import PublicLayout from "../Layout/PublicLayout";

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return <PublicLayout>{children}</PublicLayout>;
};
export default PublicRoute;
